import { withLocale } from '@/locales'

type NavigateToSimulatorGameOptions = {
  gameId?: string | number | null
  projectId?: string | number | null
  versionChange?: boolean | null
  lang: string
}

export const getSimulatorGameId = ({
  gameId,
  projectId,
}: Pick<NavigateToSimulatorGameOptions, 'gameId' | 'projectId'>) =>
  String(gameId || projectId || '')

export const getSimulatorGamePath = ({
  gameId,
  projectId,
  versionChange,
}: Omit<NavigateToSimulatorGameOptions, 'lang'>) => {
  const id = getSimulatorGameId({ gameId, projectId })
  if (!id) return '/'
  return versionChange ? `/world/${id}/profile` : `/world/${id}`
}

export const getLocalizedSimulatorGamePath = (
  options: NavigateToSimulatorGameOptions
) => withLocale(getSimulatorGamePath(options), options.lang)
